import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { EsimPlan } from "../../pages/MyEsimPage";
import { useActiveESim } from "../../hooks/useActiveESim";
import { useSnackbarStore } from "../../store/useSnackbarStore";
function ModalActiveESim({
  open,
  plan,
  onClose,
  onActive,
}: {
  open: boolean;
  plan: Omit<EsimPlan, "status" | "expiresAt"> | null;
  onClose: () => void;
  onActive: () => void;
}) {
  const isSmall = useMediaQuery("(max-width:600px)");
  const { mutate: active, isPending: isGenerating } = useActiveESim();
  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);
  const handleActiveESim = async () => {
    if (!plan) return;
    active(plan.msisdn, {
      onSuccess: (data: any) => {
        onActive();
        showSnackbar(`${data?.message || ""}`, "success");
        onClose();
      },
      onError: (err: any) => {
        showSnackbar(`${err?.response?.data?.message || ""}`, "warning");
        onClose();
      },
    });
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ pr: 6 }}>
        {plan ? plan.planName : "eSIM Details"}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {plan && (
          <Stack spacing={2} alignItems="center">
            <Stack spacing={0.25} alignItems="center">
              <Typography variant="body2" color="text.secondary">
                Do you want to activate your mobile number now? If yes, the
                validity of this number will start counting from now. If not,
                you can activate it later by dialing *5575# after you arrive at
                your destination.
              </Typography>
            </Stack>

            <Divider flexItem sx={{ width: "100%", my: 0.5 }} />
          </Stack>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          fullWidth
          size="large"
          variant="contained"
          color="primary"
          onClick={handleActiveESim}
          disabled={isGenerating}
        >
          {isGenerating ? <CircularProgress size={26} /> : "Activate"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default ModalActiveESim;
